import React from "react"
import ek from "../../static/ek.jpg"
import petnat from "../../static/petnat.jpg"
import logo from "../../static/uddacider_apple.jpg"
import uddaText from "../../static/udda_text.jpg"
import "./index.css"

const Ek = () => (
  <img className="object-contain" src={ek}></img>
)

const Petnat = () => (
  <a href="https://www.systembolaget.se/produkt/cider-blanddrycker/udda-cider-3201101/">
    <img className="object-contain" src={petnat}></img>
  </a>
)

const Contact = () => (
  <div className="mt-12" style={{ padding: "20px" }}>
    <h3>Kontakt</h3>
    <a href="mailto:anton@uddacider.se">anton@uddacider.se</a>
  </div>
)

export default function Home() {
  return (
    <>
      {process.env.NODE_ENV === "production" && (
        <head>
          <script
            defer
            src="https://cloud.umami.is/script.js"
            data-website-id="e3467769-d143-4545-ad1f-8998d20f296b"
          ></script>
        </head>
      )}
      <header className="container text-center py-14 mx-auto">
        <img src={logo} alt="logo" className="mx-auto max-w-48" />
        <img src={uddaText} alt="logo" className="mx-auto max-w-48" />
      </header>
      <h1 className="text-3xl font-garamond p-2">
        Vildjäst cider från Stockholm på 100% frukt
      </h1>

      {/* <img src={apple} alt="apple" className="my-10 max-w-md mx-auto" /> */} 

      <Contact />
    </>
  )
}
